import { Toolbar } from 'common/ProseInput/components/Toolbar'
import { useCollabItemContext } from 'components/CollabItem/CollabItem'
import { CTAProps, CommentForm } from 'components/CommentForm/CommentForm'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useRootStore } from 'stores/RootStore'
import Styles from './ItemEditForm.module.scss'

import { ItemEditFormProps } from './Types'
import { Button } from 'blaze-ui/Button'
import { noop } from 'lodash'

const PrimaryCTA = (props: CTAProps) => {
  return (
    <Button size="sm" {...props}>
      Update
    </Button>
  )
}

const ItemEditForm = observer(({ comment }: ItemEditFormProps) => {
  const rootStore = useRootStore()
  const richText = useFlipperFlag('richtext_comments')
  const { setEditing } = useCollabItemContext()
  const [newValue, setNewValue] = useState(richText ? comment.html_comment : comment.comment)
  const [newMentionedUserIds, setNewMentionedUserIds] = useState<number[]>([])

  const handleSubmit = async () => {
    rootStore.comments.update(comment.id, { comment: newValue }, newMentionedUserIds, richText)
    setEditing(undefined)
  }

  const handleChange = (value: string, mentionedUserIds: number[]) => {
    setNewValue(value)
    setNewMentionedUserIds(mentionedUserIds)
  }

  useEffect(() => {
    if (richText && comment.html_comment) {
      setNewValue(comment.html_comment)
    }
  }, [richText, comment.html_comment])

  return (
    <CommentForm
      autoFocus
      value={newValue}
      onChange={handleChange}
      onSubmit={handleSubmit}
      className={Styles.form}
      onCancel={() => setEditing(undefined)}
      showAvatar={false}
      primaryCta={<PrimaryCTA onPress={noop} isDisabled={false} />}
      inputContainerClassName={Styles.inputContainer}
      isHtmlComment={richText}
      footer={
        richText && (
          <Toolbar.Root>
            <Toolbar.Bold />
            <Toolbar.BulletList />
            <Toolbar.Mention />
          </Toolbar.Root>
        )
      }
    />
  )
})

export { ItemEditForm }
